module.exports = __webpack_public_path__ + "static/media/SA.0761a097.png";